import React from 'react'
import TabBar from './TabBar'
import SearchInput from '../../../../components/SearchInput'
import Button from '../../../../components/Button'

const Filters = ({ tabBarValue, setTabBarValue }) => {
  return (
    <div className="d-flex flex-lg-row flex-column align-items-center gap-2 justify-content-between mt-4 mb-4">
      <TabBar tabBarValue={tabBarValue} setTabBarValue={setTabBarValue} />
      <div className="d-flex align-items-center gap-2">
        <SearchInput placeHolder="Buscar por nombre o correo" />
        <Button>Buscar</Button>
      </div>
    </div>
  )
}

export default Filters
